import './ticket_count_card_view.js.coffee'
Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.PendingTicketsView extends CustomerVisualMode.Charts.TicketCountCardView
  initialize: ({clickable, count}) ->
    @id = 'pending_tickets'
    @clickable = clickable
    @count = count
    @statusClass = 'pending-tickets'
    @title = I18n.t('customer_visual_mode.charts.ticket_count.pending')

  render: ->
    super()
    @$el.html @template({
      clickable: @clickable,
      count: @count,
      precision: 0
      unit: ''
      iconClass: @iconClass,
      title: @title
    })
    @$('.status-icon').html(@_iconView().render().el)
    @

  _iconView: ->
    new Common.SvgIconView(
      svgPath: 'icons/status-not-assigned.svg'
      svgId: 'status-not-assigned'
      iconClass: 'status-icon'
    )
